const lightBlue = "#CBE9FF";
const lighterBlue = "#E2F3FF";
const primary = "#48A9C2";
const gray = "#777777";
const white = "#fefefe";
const darkGreen = "#2F7E77";
const success = "#A7CA8D";
const danger = "#EC3535";
const orange = "#FF9356";
const kalbasiMaybe = "#ECC9C5";
const maleColor = "#189AD3";
const femaleColor = "#FC90AF";
const green = "#58CC02";

export {
  lightBlue,
  primary,
  gray,
  white,
  darkGreen,
  success,
  danger,
  orange,
  lighterBlue,
  kalbasiMaybe,
  maleColor,
  femaleColor,
  green,
};

const textSecondary = "rgba(0, 0, 0, 0.17)";

export { textSecondary };

const shadowSm = {
  boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.19)",
  shadowOffset: { width: 1, height: 1 },
  backgroundColor: "white",
  shadowOpacity: 0.2,
  shadowRadius: 2,
  borderRadius: 10,
  shadowColor: "rgba(0, 0, 0, 0.6)",
  elevation: 6,
};
export { shadowSm };

const chatMeSenderBackground = "#E2F3FF";
const chatNotMeSenderBackground = "#F4F3F3";
export { chatMeSenderBackground, chatNotMeSenderBackground };
